import React from 'react';

import { pluralize } from 'helpers/formatters/string_formats';

import { List } from '@buildoutinc/blueprint-react/ui/List';
import { Popover } from '@buildoutinc/blueprint-react/ui/Popover';

import { Button } from 'components/ui/button';

import type { PageUsage } from './types';

import './styles.scss';

interface Props {
  detailUrl: string;
  documents: PageUsage[];
  documentsCount: number;
}

const positionLabel = (usage: PageUsage) => {
  if (usage.lastPage) return 'Last page';
  if (usage.position) return `Page ${usage.position}`;

  return 'In library';
};

export default function UsedInPopover({ detailUrl, documents, documentsCount }: Props) {
  return (
    <Popover>
      <Popover.Trigger className="btn btn-link p-0 clickable text-decoration-underline">
        {pluralize(documentsCount, 'document')}
      </Popover.Trigger>
      <Popover.Content align="start" side="bottom" style={{ minWidth: 280, maxWidth: 360 }}>
        <Popover.Body>
          <List flush>
            {documents.map(usage => (
              <List.Item key={`${usage.documentTemplateId}-${usage.contextType}-${usage.contextId}`}>
                <List.ItemContent
                  className="used-in-popover-row d-flex justify-content-between align-items-baseline gap-3"
                >
                  <span className="used-in-popover-name text-truncate" title={usage.documentTemplateName}>
                    {usage.documentTemplateName}
                  </span>
                  <span className="text-muted text-nowrap">{positionLabel(usage)}</span>
                </List.ItemContent>
              </List.Item>
            ))}
          </List>
          <div className="mt-2">
            <Button href={detailUrl} size="sm" variant="secondary">
              Manage where this page is used
            </Button>
          </div>
        </Popover.Body>
      </Popover.Content>
    </Popover>
  );
}
